import l from './space.module.scss';

export default function Spacer() {
  return <div className={l.c}></div>;
}
